module.exports = __webpack_public_path__ + "img/icon7.8425cf10.png";